import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

const UnstyledCTAPhoneLink = dynamic(() => import('./unstyled-cta-phone-link'));

Builder.registerComponent(UnstyledCTAPhoneLink, {
  name: 'UnstyledCTAPhoneLink',
  friendlyName: 'Unstyled CTA Phone Link',
  noWrap: true,
  inputs: [
    {
      name: 'cta',
      type: 'string',
      defaultValue: 'Click Here',
      friendlyName: 'CTA Text',
    },
  ],
});
